<template>
    <div class="set">
        <div class="setBox">
            <div class="refresh" @click="refreshWalletData"><i class="el-icon-refresh"></i></div>
            <div class="box-title">设置STC+MPC联和质押STC数量参数</div>
            <div class="box-item">
                <span>质押池MPC余额</span>
                <span>{{ showDataAuto(pledgePoolMpcBalance) }} MPC</span>
            </div>
            <div class="box-item">
                <span>当前STC数量</span>
                <span>{{ stcAmt }} STC</span>
            </div>
            <div class="box-item">
                <span>设置STC数量基数</span>
                <div class="right">
                    <el-input placeholder="大于0的数字" v-model="inputStcBaseAmt"></el-input><i>STC</i>
                </div>
            </div>
            <div class="funcBox">
                <div class="box-btn" @click="confirmSetStcBase" >确认</div>
            </div>
        </div>

        <div class="setBox">
            <div class="refresh" @click="refreshWalletData"><i class="el-icon-refresh"></i></div>
            <div class="box-title">设置兑换STC的汇率</div>
            <div class="box-item">
                <span>兑换池STC余额</span>
                <span>{{ showDataAuto(exchangePoolStcBalance) }} STC</span>
            </div>
            <div class="box-item">
                <span>兑换池MPC余额</span>
                <span>{{ showDataAuto(exchangePoolMpcBalance) }} MPC</span>
            </div>
            <div class="box-item">
                <span>当前STC与XL汇率</span>
                <span>1 STC ≈ {{ stcToXlPrice }} XL</span>
            </div>
            <div class="box-item">
                <span>设置STC与XL汇率</span>
            </div>
            <div class="box-item">
                <span>1 STC ≈</span>
                <div class="right">
                    <el-input placeholder="大于0的数字" v-model="inputStcToXlPrice"></el-input><i>XL</i>
                </div>
            </div>
            <div class="box-item">
                <span>当前STC与 WINE 汇率</span>
                <span>1 STC ≈ {{ stcToMinePrice }} WINE</span>
            </div>
            <div class="box-item">
                <span>设置STC与 WINE 汇率</span>
            </div>
            <div class="box-item">
                <span>1 STC ≈</span>
                <div class="right">
                    <el-input placeholder="大于0的数字" v-model="inputStcToMinePrice"></el-input><i>WINE</i>
                </div>
            </div>
            <div class="funcBox">
                <div class="box-btn" @click="confirmSetExchangeRate" >确认</div>
            </div>
        </div>

        <!-- <div class="setBox">
            <div class="box-title">迁移数据测试</div>
            <div class="funcBox">
                <div class="box-btn" @click="confirmSync" >确认</div>
            </div>
        </div> -->

        <!-- 
        <div class="setBox">
            <div class="refresh" @click="refreshWalletData"><i class="el-icon-refresh"></i></div>
            <div class="box-title">销毁MPC</div>
            <div class="box-item">
                <span>MPC余额</span>
                <span>{{ showDataAuto(myMpcBalance) }} MPC</span>
            </div>
            <div class="box-item">
                <span>销毁数量</span>
                <div class="right">
                    <el-input placeholder="大于0的数字" v-model="burnAmount"></el-input>
                </div>
            </div>
            <div class="funcBox">
                <div class="box-btn" @click="confirmBurn">确认销毁MPC</div>
            </div>
        </div> 
        -->

    </div>
</template>

<script>
import bus from '@/assets/js/bus';
import { getUserName} from '@/assets/js/user';
import Web3 from 'web3';
export default {
	data() {
		return {
            walletAddress: "",
            web3Instance:null,
            mpcHomeContractInstance:null,
            mpcExchangeContractInstance:null,

            qaiTokenContractInstance:null,
            lpTokenContractInstance:null,

            stcAmt:0,
            inputStcBaseAmt:"",
            pledgePoolMpcBalance:0,

            exchangePoolStcBalance:0,
            exchangePoolMpcBalance:0,
            
            exchangePoolXlBalance:0,

            stcToXlPrice:0,
            stcToMinePrice:0,
            inputStcToXlPrice:"",
            inputStcToMinePrice:"",

            myMpcBalance:0,
            burnAmount:"",

		};
	},
    created() {
        bus.$on('showWalletAddress',async(msg) =>  {
            this.walletAddress = getUserName();
        });
        bus.$on('clearWalletAddress',async() =>  {
            this.web3Instance = null;
            this.mpcHomeContractInstance = null;
            this.mpcExchangeContractInstance = null;
        });
        bus.$on('refreshWalletData',async(msg) =>  {
            this.walletAddress = getUserName();
            this.initWallet();
        });
    },
    mounted() {
        if(getUserName()){
            this.hideConnectWalletBox();
            this.walletAddress = getUserName();
            this.initWallet();
        }else{
            this.showConnectWalletBox();
            this.connectWallet();
        }
    },
    methods: {
        initWallet(){
            if(this.walletAddress.toLowerCase() != this.dappAdminAddress.toLowerCase()){
                this.goHome();
                return;
            }
            this.web3Instance = new Web3(window.ethereum);
            this.mpcHomeContractInstance = new this.web3Instance.eth.Contract(this.MpcHome_Contract.abi, this.MpcHome_Contract.address);
            this.mpcExchangeContractInstance = new this.web3Instance.eth.Contract(this.MpcExchange_Contract.abi, this.MpcExchange_Contract.address);
            this.tokenXlContractInstance = new this.web3Instance.eth.Contract(this.TokenXl_Contract.abi, this.TokenXl_Contract.address);

            this.tokenMpcContractInstance = new this.web3Instance.eth.Contract(this.TokenMpc_Contract.abi, this.TokenMpc_Contract.address);
            this.tokenStcContractInstance = new this.web3Instance.eth.Contract(this.TokenStc_Contract.abi, this.TokenStc_Contract.address);

            this.refreshWalletData();
        },
        refreshWalletData(){
            this.showLoadingBox();
            this.tokenStcContractInstance.methods.balanceOf(this.MpcExchange_Contract.address).call().then((result) => {
                this.exchangePoolStcBalance = this.convertFromByUnit(result,18);
            });
            this.tokenMpcContractInstance.methods.balanceOf(this.MpcExchange_Contract.address).call().then((result) => {
                this.exchangePoolMpcBalance = this.convertFromByUnit(result,18);
            });
            this.tokenMpcContractInstance.methods.balanceOf(this.MpcHome_Contract.address).call().then((result) => {
                this.pledgePoolMpcBalance = this.convertFromByUnit(result,18);
            });
            // this.tokenMpcContractInstance.methods.balanceOf(this.walletAddress).call().then((result) => {
            //     this.myMpcBalance = this.convertFromByUnit(result,18);
            // });
            // this.tokenXlContractInstance.methods.balanceOf(this.MpcExchange_Contract.address).call().then((result) => {
            //     this.exchangePoolXlBalance = this.convertFromByUnit(result,18);
            // });
            this.mpcHomeContractInstance.methods.calcStcAmt().call().then((result) => {
                this.stcAmt = this.convertFromByUnit(result,18);
            });
            this.mpcExchangeContractInstance.methods.findPrice().call().then((result) => {
                this.stcToXlPrice = this.convertFromByUnit(result._stcToXlPrice,18);
                this.stcToMinePrice = this.convertFromByUnit(result._stcToMinePrice,18);
                this.hideLoadingBox();
            });
        },
        async confirmSetStcBase(){
            let _this = this;
            if(isNaN(this.inputStcBaseAmt) || this.inputStcBaseAmt <= 0){
                this.$message.warning({message: "无效参数",duration: 1500})
                return;
            }
            let stcAmtBigNumber = this.convertToBigNumberByUnit(this.inputStcBaseAmt,18);
            let method = this.mpcHomeContractInstance.methods.setStcBaseAmt(stcAmtBigNumber);
            let bnbAmount = null

            let gasprice = await this.web3Instance.eth.getGasPrice();
            console.log("gasPrice:",gasprice);
            method.estimateGas({from: this.walletAddress, value:bnbAmount}).then(function(result){
                console.log("estimateGas:",result);
            }).catch((err) => {
                console.log("estimateGas:",err)
            });

            this.showConfirmBox();
            this.contractSend (method,this.walletAddress,bnbAmount).then(function(result){
                _this.hideConfirmBox();
                if(result.status){
                    _this.refreshWalletData();
                    _this.$message.success({message: "修改成功",duration: 1500})
                }else{
                    _this.$message.error({message: "修改失败",duration: 1500})
                }
            }).catch((error) => {
                _this.hideConfirmBox();
                _this.$message.error({message: "修改失败",duration: 1500})
            });
        },
        async confirmSetExchangeRate(){
            let _this = this;
            if(isNaN(this.inputStcToXlPrice) || this.inputStcToXlPrice <= 0){
                this.$message.warning({message: "无效参数",duration: 1500})
                return;
            }
            if(isNaN(this.inputStcToMinePrice) || this.inputStcToMinePrice <= 0){
                this.$message.warning({message: "无效参数",duration: 1500})
                return;
            }
            let rateBigNumber1 = this.convertToBigNumberByUnit(this.inputStcToXlPrice,18);
            let rateBigNumber2 = this.convertToBigNumberByUnit(this.inputStcToMinePrice,18);
            let method = this.mpcExchangeContractInstance.methods.setStcPrice(rateBigNumber1,rateBigNumber2);
            let bnbAmount = null

            let gasprice = await this.web3Instance.eth.getGasPrice();
            console.log("gasPrice:",gasprice);
            method.estimateGas({from: this.walletAddress, value:bnbAmount}).then(function(result){
                console.log("estimateGas:",result);
            }).catch((err) => {
                console.log("estimateGas:",err)
            });

            this.showConfirmBox();
            this.contractSend (method,this.walletAddress,bnbAmount).then(function(result){
                _this.hideConfirmBox();
                if(result.status){
                    _this.refreshWalletData();
                    _this.$message.success({message: "修改成功",duration: 1500})
                }else{
                    _this.$message.error({message: "修改失败",duration: 1500})
                }
            }).catch((error) => {
                _this.hideConfirmBox();
                _this.$message.error({message: "修改失败",duration: 1500})
            });
        },
        async confirmBurn(){
            if(isNaN(this.burnAmount) || this.burnAmount <= 0){
                this.$message.warning({message: "无效参数",duration: 1500})
                return;
            }
            let mpcFinalBigNumber = this.convertToBigNumberByUnit(this.burnAmount,18);
            this.showConfirmBox(2,"MPC");
            let mpcAllowance = await this.tokenMpcContractInstance.methods.allowance(this.walletAddress, this.MpcHome_Contract.address).call();
            let mpcAllowanceBigInt = this.convertToBigIntByUnit(mpcAllowance,0);
            let finalBigInt = this.convertToBigIntByUnit(2000000,18)
            if(finalBigInt > mpcAllowanceBigInt){
                if(!await this.tokenApprove(this.tokenMpcContractInstance,this.walletAddress,this.MpcHome_Contract.address,mpcFinalBigNumber)){
                    this.$message.warning({message:  this.$t("common.approveMpcFail"),duration: 1500});
                    this.hideConfirmBox();
                    return;
                }
            }
            this.setConfirmBox(2);

            let method = this.mpcHomeContractInstance.methods.testBurnMPc(mpcFinalBigNumber);
            let bnbAmount = null;
            let gasprice = await this.web3Instance.eth.getGasPrice();
            console.log("gasPrice:",gasprice);
            method.estimateGas({from: this.walletAddress, value:bnbAmount}).then(function(result){
                console.log("estimateGas:",result);
            }).catch((err) => {
                console.log("estimateGas:",err)
            });
            let _this = this;
            this.contractSend(method,this.walletAddress,bnbAmount).then(function(result){
                _this.hideConfirmBox();
                if(result.status){
                    _this.refreshWalletData();
                    _this.$message.success({message: "修改成功",duration: 1500})
                }else{
                    _this.$message.error({message: "修改失败",duration: 1500})
                }
            }).catch((error) => {
                _this.hideConfirmBox();
                _this.$message.error({message: "修改失败",duration: 1500})
            });
        },
        showMethodGas(method,name){
            method.estimateGas({from: this.walletAddress, value:null}).then(function(result){
                console.log(name + " estimateGas:",result);
            }).catch((err) => {
                console.log(name + " estimateGas:",err)
            });
        },
        async confirmSync(){
            let address = "0x6365e38019b52d5fc3427a254a90b12c1422506d";
            console.log(address);
            let addressList = [address];
            let method;
            // let method = this.mpcHomeContractInstance.methods.syncPledgeAll([address]);
            let bnbAmount = null;

            method = this.mpcHomeContractInstance.methods.syncPledgeAll(addressList);
            this.showMethodGas(method,"syncPledgeAll");

            method = this.mpcHomeContractInstance.methods.syncPledgeMerge(address);
            this.showMethodGas(method,"syncPledgeMerge");

            let amtFinalBigNumber = this.convertToBigNumberByUnit(10,18);
            method = this.mpcHomeContractInstance.methods.syncPledgeMerge2(address,amtFinalBigNumber,amtFinalBigNumber,amtFinalBigNumber,amtFinalBigNumber);
            this.showMethodGas(method,"syncPledgeMerge2");

            // let _this = this;
            // this.contractSend(method,this.walletAddress,bnbAmount).then(function(result){
            //     _this.hideConfirmBox();
            //     if(result.status){
            //         _this.refreshWalletData();
            //         _this.$message.success({message: "修改成功",duration: 1500})
            //     }else{
            //         _this.$message.error({message: "修改失败",duration: 1500})
            //     }
            // }).catch((error) => {
            //     _this.hideConfirmBox();
            //     _this.$message.error({message: "修改失败",duration: 1500})
            // });
        }
    },
    beforeDestroy() {
    }
};
</script>
<style lang='less'>
.set{
    background-color: #E5ECFF;
    .box-item{
        input{
            border: 1px solid #dddddd;
            background: transparent;
            font-size:14px;
            color: #000000;
            padding: 6px 10px;
            height: 100%;
            width: 140px;
        }
        input::-webkit-input-placeholder{
            font-size:13px;
            color: #cccccc;
        }
    }
    .item-date{
        input{
            border: 1px solid #000000;
            background: transparent;
            font-size:14px;
            color: #000000;
            padding: 10px 30px;
            height: 100%;
        }
        .el-input__icon{
            line-height: 37px;
            color: #000000;
        }
    }
}
</style>
<style lang='less' scoped>
.set{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap:12px;
    padding-bottom: 50px;
    .setBox{
        margin: 0 10px;
        border-radius: 10px;
        padding: 15px 10px;
        border-radius: 10px;
        background-color: #ffffff;
        color: #000000;
        display: flex;
        flex-direction: column;
        gap:12px;
        position: relative;
        .refresh{
            color: blue;
            font-size: 18px;
            position: absolute;
            right: 10px;
            top: 10px;
            font-weight: bolder;
            cursor: pointer;
        }
        .box-btn{
            width: 100%;
            height: 35px;
            color:#ffffff;
            font-size:13px;
            text-align: center;
            margin: 10px auto auto;
            line-height: 35px;
            cursor: pointer;
            background: linear-gradient(90deg, #3F5BB3, #6387FA);
            border-radius: 5px;
        }
        .disabled{
            color: #666666!important;
            background: linear-gradient(-90deg, #999999, #cccccc)!important;
        }
        .box-title{
            font-size: 18px;
            font-weight: bolder;
            color: #000000;
            display: flex;
            justify-content: center;
        }
        .box-item{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .addressList{
                display: flex;
                flex-direction: column;
                gap:5px;
                span{
                    font-family: monospace; 
                }
            }
            span{
                font-size: 13px;
                text-align: left;
                color: #000000;
            }
            .right{
                display: flex;
                align-items: center;
                i{
                    font-size: 13px;
                    text-align: left;
                    color: #000000; 
                    font-style: normal;
                    margin-left: 5px;
                    width:30px;
                }
            }
        }
        .funcBox{
            display: flex;
            align-items: center;
            gap:20px;
            justify-content: space-between;
        }
    }
}
</style>